import clsx from 'clsx';
import type React from 'react';

import { Layout, LayoutRoot } from './Layout';
import styles from './PageWallpaper.module.css';

export function PageWallpaper(props: {
    className?: string;
    children: React.ReactNode;
    imageLight: string;
    imageDark: string;
}) {
    return (
        <GradientBackground
            imageLight={props.imageLight}
            imageDark={props.imageDark}
            className={props.className}
        >
            {props.children}
        </GradientBackground>
    );
}

export function PageWallpaperSection(props: {
    className?: string;
    children: React.ReactNode;
    imageLight: string;
    imageDark: string;
}) {
    return (
        <LayoutRoot layout="centered">
            <GradientBackground
                imageLight={props.imageLight}
                imageDark={props.imageDark}
                className={props.className}
            >
                <Layout>{props.children}</Layout>
            </GradientBackground>
        </LayoutRoot>
    );
}

function GradientBackground(props: {
    children?: React.ReactNode;
    imageLight: string;
    imageDark: string;
    className?: string;
    style?: React.CSSProperties;
}) {
    const { children, imageLight, imageDark } = props;

    return (
        <>
            <div
                className={clsx('w-full', styles.bgGradient, props.className)}
                style={
                    {
                        '--bg-image-light': imageLight ? `url(${imageLight})` : undefined,
                        '--bg-image-dark': imageDark ? `url(${imageDark})` : undefined,
                        ...props.style,
                    } as React.CSSProperties
                }
            >
                {children}
            </div>
            <link rel="preload" as="image" href={imageLight} />
            <link rel="preload" as="image" href={imageDark} />
        </>
    );
}
